<mat-card class="load-summary-card">
  <h2 class="mat-headline">Load Summary</h2>

  <div class="controls">
    <mat-form-field appearance="fill" class="load-select">
      <mat-label>Select Load</mat-label>
      <mat-select [(ngModel)]="selectedLoadId">
        <mat-option [value]="null">-- Select --</mat-option>
        <mat-option *ngFor="let l of assignedLoads" [value]="l.id">
          {{ l.name }} ({{ l.state }})
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="fetchSummary()">Fetch</button>
  </div>

  <div *ngIf="loadName" class="load-header mat-subheading-2">
    <strong>Load:</strong> {{ loadName }}
  </div>

  <div *ngIf="rows.length === 0" class="empty">
    <mat-icon>info</mat-icon> No data.
  </div>

  <div *ngIf="rows.length > 0" class="table-wrapper">
    <table class="summary-table mat-elevation-z2">
      <thead>
        <tr>
          <th>#</th>
          <th>Customer</th>
          <th>Cash</th>
          <th>UPI</th>
          <th>Cheque</th>
          <th>Bank</th>
          <th>Other</th>
          <th>Discount</th>
          <th>Good Qty</th>
          <th>Damaged Qty</th>
          <th>Expired Qty</th>
          <th>Due Qty</th>
          <th>Return Amount</th>
          <th>Customer Balance</th>
          <th>Total Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of rows">
          <td>{{ r.slno }}</td>
          <td>{{ r.customerName }}</td>
          <td>{{ r.cash | number:'1.2-2' }}</td>
          <td>{{ r.upi | number:'1.2-2' }}</td>
          <td>{{ r.cheque | number:'1.2-2' }}</td>
          <td>{{ r.bank | number:'1.2-2' }}</td>
          <td>{{ r.other | number:'1.2-2' }}</td>
          <td>{{ r.discount | number:'1.2-2' }}</td>
          <td>{{ r.returnQtyGood | number:'1.0-3' }}</td>
          <td>{{ r.returnQtyDamaged | number:'1.0-3' }}</td>
          <td>{{ r.returnQtyExpired | number:'1.0-3' }}</td>
          <td>{{ r.returnQtyDue | number:'1.0-3' }}</td>
          <td>{{ r.returnAmount | number:'1.2-2' }}</td>
          <td>{{ r.customerBalance | number:'1.2-2' }}</td>
          <td>{{ r.totalAmount | number:'1.2-2' }}</td>
        </tr>
      </tbody>
      <tfoot *ngIf="totals">
        <tr class="totals-row">
          <td colspan="2"><strong>Totals</strong></td>
          <td>{{ totals.cash | number:'1.2-2' }}</td>
          <td>{{ totals.upi | number:'1.2-2' }}</td>
          <td>{{ totals.cheque | number:'1.2-2' }}</td>
          <td>{{ totals.bank | number:'1.2-2' }}</td>
          <td>{{ totals.other | number:'1.2-2' }}</td>
          <td>{{ totals.discount | number:'1.2-2' }}</td>
          <td>{{ totals.returnQtyGood | number:'1.0-3' }}</td>
          <td>{{ totals.returnQtyDamaged | number:'1.0-3' }}</td>
          <td>{{ totals.returnQtyExpired | number:'1.0-3' }}</td>
          <td>{{ totals.returnQtyDue | number:'1.0-3' }}</td>
          <td>{{ totals.returnAmount | number:'1.2-2' }}</td>
          <td>{{ totals.customerBalance | number:'1.2-2' }}</td>
          <td>{{ totals.totalAmount | number:'1.2-2' }}</td>
        </tr>
      </tfoot>      
    </table>
  </div>
</mat-card>
